import { actionFactory } from 'redux/factories';
import { types } from './types';

export const getInvoiceTypes = actionFactory(types.GET_INVOICE_TYPES);
export const createInvoiceType = actionFactory(types.CREATE_INVOICE_TYPE);
export const updateInvoiceType = actionFactory(types.UPDATE_INVOICE_TYPE);
export const deleteInvoiceType = actionFactory(types.DELETE_INVOICE_TYPE);
